import MessagingConfiguration from 'models/messaging_configuration';

export default class UpdateMessagingConfiguration {
  constructor(context) {
    this.context = context;
  }

  run({
    agentCapacity,
    agentMaxCapacity,
    assignMailToConversationAssignee,
    autoAssignMessagingSessions,
    endMailSessionIntervalMins,
    endMessagingSessionIntervalMins,
    routeNextMessagingSessionIntervalSecs,
    showPreview,
  }) {
    let newMessagingConfigAttrs = {
      agentCapacity,
      agentMaxCapacity,
      assignMailToConversationAssignee,
      autoAssignMessagingSessions,
      routeNextMessagingSessionIntervalSecs,
      endMailSessionIntervalMins,
      endMessagingSessionIntervalMins,
      showPreview,
    };

    const currentMessagingConfig = this.context.stores.messagingConfiguration.get();
    if (
      currentMessagingConfig.assignMailToConversationAssignee !== assignMailToConversationAssignee &&
      assignMailToConversationAssignee
    ) {
      newMessagingConfigAttrs.endMailSessionIntervalMins = 0;
    }

    this.context.stores.messagingConfiguration.setPending(MessagingConfiguration.create(newMessagingConfigAttrs));
    this.context.gateways.messagingConfiguration.replace(newMessagingConfigAttrs);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/endpoint/update_messaging_configuration.js